import React from 'react'
import PropTypes from 'prop-types'
import MediaQueryMatch from '@pcln/media-query-match'
import { pclnExpt } from '../../../../common/fly-experimentation/fly-experimentation.js'
import { HotelCrossSellComponent as DefaultHotelCrossSellComponent } from '../../../../common-components/hotel-cross-sell-component.js'
import { HotelCrossSellComponent as VariantHotelCrossSellComponent } from '@pcln/bundle-and-save-components'
import { MobileHotelCrossSellComponent } from '../../../../common-components/mobile-hotel-cross-sell-component.js'
import {
  getTopMarketImgObj,
  isTopMarket,
  isNewTopMarket,
} from '../../../../details-client/util/getTopMarketImgObj'
import get from 'lodash/get'

function buildQueryString(data) {
  return Object.keys(data)
    .map(key => {
      return [key, data[key]].map(encodeURIComponent).join('=')
    })
    .join('&')
}

class CrossSellGenericAd extends React.Component {
  componentDidMount() {
    this.props.flyGaLogic.fireGtm(
      'send',
      'event',
      'MFLY-Listings',
      'Package banner display'
    )
    const destination = this.props?.searchParams?.slices?.[0]
      ?.destinationAirport

    if (isNewTopMarket(destination)) {
      pclnExpt.fireImpression('PKG_FLIGHT_LISTINGS_NEW_DESTINATION_PROMOS')
    }

    if (window?.innerWidth <= 768) {
      pclnExpt.fireImpression('REMOVE_BUNDLEPROMO_FLISTING_WMOBILE')
    }

    if (window?.innerWidth > 768) {
      pclnExpt.fireImpression('PKG_FE_DESKTOP_NEW_LISTINGS_XSELL_BANNER')
    }
  }

  handleItemClick = () => {
    const { searchParams } = this.props
    const { slices, params, numberOfPassengers } = searchParams

    const queryStringParams = {
      origin: slices[0].originAirport,
      'origin-type': slices[0].originAirportType || 'AIRPORT',
      destination: slices[1].originAirport,
      'origin-city': slices[0].originCityName,
      'destination-city': slices[0].destinationCityName,
      'destination-type': slices[0].destinationAirportType || 'AIRPORT',
      'departure-date': slices[0].travelDateAsYYYYMMDD,
      'return-date': slices[1].travelDateAsYYYYMMDD,
      'num-adults': params['num-adults'] || 0,
      'num-youths': params['num-youths'] || 0,
      'num-children': params['num-children'] || 0,
      'num-lap-infants': params['num-infants'] || 0,
      'num-rooms': numberOfPassengers > 4 ? 2 : 1,
    }

    this.props.flyGaLogic.fireGtm(
      'send',
      'event',
      'MFLY-Listings',
      'Package banner click'
    )

    const queryString = buildQueryString(queryStringParams)
    const baseUrl = window.location.origin
    window.open(`${baseUrl}/shop/search?${queryString}`)
  }

  render() {
    const isVariant = get(
      this.props?.seti,
      'PKG_FE_FLIGHTS_BUNDLE_PROMO_MSG.isVariant',
      false
    )

    const HotelCrossSellComponent = get(
      this.props.seti,
      'PKG_FE_DESKTOP_NEW_LISTINGS_XSELL_BANNER.isVariant',
      false
    )
      ? VariantHotelCrossSellComponent
      : DefaultHotelCrossSellComponent

    const shouldHideMobileBanner = get(
      this.props?.seti,
      'REMOVE_BUNDLEPROMO_FLISTING_WMOBILE.isVariant',
      false
    )

    const destination = this.props?.searchParams?.slices?.[0]?.destinationCityName?.split(
      ','
    )?.[0]
    const savingsText = isVariant
      ? 'Save even more on your trip'
      : 'Save an average of $240 on your trip'
    const headingText =
      savingsText + ' to ' + destination + (isVariant ? '!' : '')
    const headingCopy =
      (isVariant && destination) ||
      isTopMarket(destination) ||
      isNewTopMarket(destination)
        ? headingText
        : savingsText

    const subheadingCopy = isVariant
      ? 'Easily manage your trip details and maximize your savings when you book a hotel and flight together.'
      : 'Book a Hotel + Flight together for extra savings.'

    const btnText = isVariant
      ? 'View Hotel + Flights Deals'
      : 'Hotel + Flight Deals'

    const hotelXSellProps = {
      flyGaLogic: this.props.flyGaLogic,
      handleItemClick: this.handleItemClick,
      headerFontSize: isVariant ? 3 : 2,
      imgWidth: ['107px', '107px', '107px', '246px', '246px'],
      bannerMx: [2, 2, 2, 2, 0],
      isButtonStyle: false,
      buttonLayout: 'row',
      headerColour: 'text.base',
      headingCopy: headingCopy,
      subheadingCopy: subheadingCopy,
      btnCopy: btnText,
      imgObj: getTopMarketImgObj(destination) || getTopMarketImgObj('GEN'),
      isVariant: isVariant,
    }

    return (
      <>
        {!shouldHideMobileBanner && (
          <MediaQueryMatch maxWidth={'lg'}>
            <MobileHotelCrossSellComponent
              flyGaLogic={this.props.flyGaLogic}
              handleItemClick={this.handleItemClick}
              bannerMx={[2, 2, 2, 2, 0]}
              headingCopy={headingCopy}
              subheadingCopy={subheadingCopy}
              btnCopy={btnText}
              isVariant={isVariant}
            />
          </MediaQueryMatch>
        )}
        <MediaQueryMatch minWidth={'lg'}>
          <HotelCrossSellComponent
            mx={[2, 2, 2, 2, 0]}
            headingCopy={headingCopy}
            isLightBackground
            handleClick={this.handleItemClick}
            {...hotelXSellProps}
          />
        </MediaQueryMatch>
      </>
    )
  }
}

CrossSellGenericAd.propTypes = {
  flyGaLogic: PropTypes.object.isRequired,
  searchParams: PropTypes.shape({
    slices: PropTypes.array.isRequired,
    params: PropTypes.object.isRequired,
    numberOfPassengers: PropTypes.number.isRequired,
  }).isRequired,
  seti: PropTypes.object,
}

export { CrossSellGenericAd }
